import Marionette from "marionette";
import CkEditor5Template from "./template/ckEditor5Template.html";
import CKEditorInspector from "@ckeditor/ckeditor5-inspector";
import { ClassicEditor } from "ckeditor5";
import Messenger from "messaging/messenger";

const displayModes = {
  INLINE: "inline",
  WIDE_SIDEBAR: "wideSidebar",
};

// noinspection JSUnusedGlobalSymbols
const CkEditor5View = {
  ckEditor5View: Marionette.ItemView.extend({
    className: "ckeditor",
    enableInspector: false,
    template: CkEditor5Template,
    ui: {
      responseSidebarContainer: ".response-viewer-sidebar",
    },
    ckeditor: null,
    commitData: function () {
      // Make sure that if the Source Editor is open, that it commits any changes
      if (this.ckeditor && this.ckeditor.plugins && this.ckeditor.plugins.has("SourceEditing")) {
        const sourceEditing = this.ckeditor.plugins.get("SourceEditing");
        if (sourceEditing.isSourceEditingMode) {
          sourceEditing.isSourceEditingMode = false;
        }
      }
    },
    onItemBeforeClose: function () {
      if (this.ckeditor) {
        this.ckeditor.destroy().catch((err) => console.error(err));
        this.ckeditor = null;
      }
    },
    getResponse: function () {
      //get response from CKEditor
      if (this.ckeditor) {
        this.commitData();
        return this.ckeditor.getData();
      }
      return "";
    },
    getCloudDocumentVersion: function () {
      if (
        this.ckeditor &&
        this.ckeditor.plugins &&
        this.model.get("collaborationEnabled") &&
        this.ckeditor.plugins.has("RealTimeCollaborationClient")
      ) {
        const realTimeCollaborationClient = this.ckeditor.plugins.get(
          "RealTimeCollaborationClient",
        );
        return realTimeCollaborationClient.cloudDocumentVersion;
      }
      return null;
    },
    onRender: function () {
      this.$el.i18n();
      this.ckeditor = null;
      const config = this.model.attributes;
      if (config.collaborationEnabled) {
        config.comments = {
          editorConfig: {},
        };
        config.sidebar = {
          container: this.ui.responseSidebarContainer[0],
        };
        config.revisionHistory = {
          editorContainer: this.$el.find(".editor-container")[0],
          viewerContainer: this.$el.find(".revision-viewer-container")[0],
          viewerEditorElement: this.$el.find(".revision-viewer-editor")[0],
          viewerSidebarContainer: this.$el.find(".revision-viewer-sidebar")[0],
        };
        config.presenceList = {
          container: this.$el.find(".presence-list-container")[0],
        };
      }
      ClassicEditor.create(this.$el.find(".ckeditor-placeholder")[0], this.model.attributes)
        .then((editor) => {
          //console.log("Available tools:", Array.from(editor.ui.componentFactory.names()));

          // Note: Do not use the editor.setData() or editor.data.set() methods when using the
          // collaboration plugin. These simply overwrite the whole content of the editor
          // (even if the data to set is the same as the current editor data). In real-time
          // collaboration, this behavior can result in overwriting other clients’ local updates.
          // In most cases, using editor.setData() and editor.data.set() in real-time collaboration
          // is incorrect.
          console.log(Array.from(editor.ui.componentFactory.names()));
          console.log(
            "Plugins:",
            this.model.attributes.plugins.map((p) => p.name || p.toString()),
          );
          this.ckeditor = editor;
          if (this.enableInspector) {
            CKEditorInspector.attach(editor);
          }
          editor.model.document.on("change:data", (eventInfo, batch) =>
            this.trigger("change:data", eventInfo, batch),
          );
          // Note: do not use editor.setData() as it triggers change:data event when the editor is
          // initialized even if the response is not changed. This mean isDirty() will return
          // true and we do not want this. Instead, set initial data using editor config when
          // collaboration is disabled.

          editor.on("messenger:request", (_eventInfo, args) =>
            Messenger.reqres.request.apply(Messenger.reqres, args),
          );
          this.trigger("editor:initialized");
        })
        .catch((err) => {
          console.error(err);
          this.trigger("editor:initializeError", err);
        });
    },
    activateBothInlineModeAndWideSidebarMode: function (annotationsUIs) {
      if (
        !annotationsUIs &&
        this.ckeditor &&
        this.ckeditor.plugins &&
        this.ckeditor.plugins.has("AnnotationsUIs")
      ) {
        annotationsUIs = this.ckeditor.plugins.get("AnnotationsUIs");
      }
      if (annotationsUIs) {
        annotationsUIs.deactivateAll();
        this.ui.responseSidebarContainer.removeClass("hidden");
        annotationsUIs.activate(
          displayModes.WIDE_SIDEBAR,
          (annotation) => annotation.type === "comment",
        );
        annotationsUIs.activate(displayModes.INLINE, (annotation) =>
          annotation.type.startsWith("suggestion"),
        );
      }
    },
    switchDisplayModeToInline: function (annotationsUIs) {
      if (
        !annotationsUIs &&
        this.ckeditor &&
        this.ckeditor.plugins &&
        this.ckeditor.plugins.has("AnnotationsUIs")
      ) {
        annotationsUIs = this.ckeditor.plugins.get("AnnotationsUIs");
      }
      if (annotationsUIs) {
        annotationsUIs.deactivateAll();
        annotationsUIs.switchTo(displayModes.INLINE);
      }
      this.ui.responseSidebarContainer.addClass("hidden");
    },
  }),
};

export default CkEditor5View;
